module.exports = __webpack_public_path__ + "static/media/IconoUnidadesFormacion.1c421124.svg";